import Modal from 'react-bootstrap/Modal';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { Link } from 'react-router-dom';

function ModalConfirm(props) {

    const { confirmData, handleClose } = props;

    return (<>
        <Modal className="dialogbox" show={!!confirmData}>
            <div className="modal-icon text-success">
                <IoCheckmarkCircle />
            </div>
            <Modal.Header>
                <Modal.Title>Prenotazione confermata</Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-14 px-2 lh-16 text-gray'>Grazie per aver effettuato la prenotazione. Riceverai per email la conferma d'ordine. Una mail di notifica è stata inviata anche al cliente.</Modal.Body>
            <Modal.Footer>
                <div className="btn-inline">
                    <a className="btn" onClick={handleClose}>
                        VISUALIZZA PRENOTAZIONE
                    </a>
                </div>
            </Modal.Footer>
        </Modal>
    </>);

}

export default ModalConfirm;